import { TYPES_TO_NAMES } from '@blisspointmedia/bpm-types/dist/LinearBuying';
import { downloadJSONToCSV } from '@src/utils/download-utils';
import { LogSummaries, LogSummaryRow } from './use-admin-data';

export interface LogSummariesWithConfirmedDNRs extends LogSummaries {
  confirmedDNRs: LogSummaryRow[];
}

const isRowInDateRange = (start: string, end: string) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  return (row: LogSummaryRow): boolean => {
    const rowDate = new Date(row.week);
    return rowDate <= endDate && rowDate >= startDate;
  };
};

export const filterLogSummariesByDateRange = (
  logSummaries: LogSummariesWithConfirmedDNRs,
  start: string,
  end: string
): LogSummariesWithConfirmedDNRs => {
  const inRange = isRowInDateRange(start, end);
  return {
    duplicates: logSummaries.duplicates.filter(inRange),
    unaccepted: logSummaries.unaccepted.filter(inRange),
    potentiallyMissing: logSummaries.potentiallyMissing.filter(inRange),
    overspend: logSummaries.overspend.filter(inRange),
    prelogsOnly: logSummaries.prelogsOnly.filter(inRange),
    linearReconciliationStatus: logSummaries.linearReconciliationStatus.filter(inRange),
    confirmedDNRs: logSummaries.confirmedDNRs.filter(inRange)
  };
};

const getRowsWithFriendlyTypes = (rows: LogSummaryRow[]): LogSummaryRow[] =>
  rows.map(row =>
    row.type && TYPES_TO_NAMES[row.type] ? { ...row, type: TYPES_TO_NAMES[row.type] } : row
  );

export const downloadAllTables = (data: LogSummaries, fileName: string): void => {
  if (!(data && fileName)) {
    console.error('Must provide data and fileName to download JSON to CSV');
    return;
  }
  Object.entries(data).forEach(([table, rows]) => {
    downloadJSONToCSV(getRowsWithFriendlyTypes(rows), table);
  });
};
